import { createStore } from "vuex";
export default createStore({
  state: {
    Authorization: window.sessionStorage.getItem("token"),
    userInfo: window.sessionStorage.getItem("userInfo"),
    windowWidth: window.innerWidth,
    scrollTop: document.documentElement.scrollTop,
    theme: window.sessionStorage.getItem("theme"),
    commonCallback: null // 通用的回调函数
  },
  mutations: {
    async setAuthorization(state, auth) {
      state.Authorization = auth;
      window.sessionStorage.setItem("token", auth);
    },
    async setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      window.sessionStorage.setItem("userInfo", userInfo);
    },
    async setWindowWidth(state, width) {
      state.windowWidth = width;
    },
    async setScrollTop(state, scrollTop) {
      state.scrollTop = scrollTop;
    },
    async setTheme(state, theme) {
      state.theme = theme;
      window.sessionStorage.setItem("theme", theme);
    },
    // 添加通用的回调函数<用于跨页面的事件回调，请在执行commonCallback函数之后立即设置为null>
    setCommonCallback(state, callback) {
      state.commonCallback = callback;
    }
  },
  getters: {
    // 获取用户信息
    getUserInfo(state) {
      return state.userInfo;
    },
    // 获取token
    getToken(state) {
      return state.Authorization;
    },
    // 获取窗口宽度
    getWindowWidth(state) {
      return state.windowWidth;
    },
    // 获取滚动条位置
    getScrollTop(state) {
      return state.scrollTop;
    },
    // 获取主题
    getTheme(state) {
      return state.theme;
    },
  },
  actions: {},
  modules: {},
});
